/* eslint no-shadow: "off", no-param-reassign: ["error", { "props": false }], no-console: "off", quotes: "off" */

import axios from "axios";
import auth from "../../../common/auth";

export default {
  // eslint-disable-next-line
  createUserAccount({ commit, rootState }, registrationData) {
    // eslint-disable-next-line
    const { msisdn, username, password, lang, fbReferral, freePlayPoints, prize, operator } = registrationData;
    const { inviteReferral } = rootState.common;
    return axios({
      url: `api/subscribeUser?msisdn=${msisdn}&username=${username}&password=${password}&lang=${lang}&fbReferral=${fbReferral}&freePlayPoints=${freePlayPoints}&prize=${prize}&inviteReferral=${inviteReferral}&operator=${operator}`,
      method: 'GET',
      headers: {
        Authorization: auth.getJwt(),
      },
    }).catch((error) => {
      console.log(`Something went wrong while creating user account: ${error}`);
    });
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/registration/actions.js